// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bFR6eCdcf2a2G1 {
  box-sizing: content-box;
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  background-clip: padding-box;
  background-origin: padding-box;
  border-radius: 3px;
  opacity: 0.8;
  padding: 4px;
  position: absolute;
  right: 2px;
  top: 2px;
  visibility: hidden;
  z-index: 40;
}
.bFR6eCdcf2a2G1:hover {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  opacity: 1;
}
.bFR6eCdcf2a2G1:active {
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  opacity: 1;
}
.bFR6eCdcf2a2G1.A4pjPdipfztplq {
  visibility: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editCardButton": `bFR6eCdcf2a2G1`,
	"show": `A4pjPdipfztplq`
};
export default ___CSS_LOADER_EXPORT___;
